// extracted by mini-css-extract-plugin
export default {"breadcrumbs":"cHiBwaWWvTXSU09EQvgQ"};